import { raygun } from '@ynap/clientside-monitoring';

export const trackAnalyticsError = (error) => {
    raygun.helpers.agent('send', {
        error,
        tags: ['analytics'],
    });
};
